module.exports = __webpack_public_path__ + "static/img/login.83e47cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login.png
// module id = 6QGk
// module chunks = 1